export enum SortByEnum {
  NAME_DESC = 'NAME_DESC',
  NAME_ASC = 'NAME_ASC',
  DATE_DESC = 'DATE_DESC',
  DATE_ASC = 'DATE_ASC',
}
